import type React from 'react';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import SettingStyles from '../SettingStyle.module.scss';
import { SubtypeList } from '~/components/specifics/settings/subtypes/SubtypeList';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <h2 className={SettingStyles.SettingTitle}>案件タイプ設定</h2>
      <SubtypeList />
    </ClientSettingLayout>
  </DefaultV2>
);
